const DiscoverCollectionList = 
[   {
      id: 1,
      link: "collection1.png",
      link2: "collection2.png",
      link3: "collection3.png",
      discoverpara: "3D lllustrations",
      discoverresource :"280 resources"
   },
   {
    id: 1,
    link: "collection4.png",
    link2: "collection4.png",
    link3: "collection4.png",
    discoverpara: "Insta templates",
    discoverresource :"80 resources"
 },{
    id: 1,
    link: "collection11.png",
    link2: "collection9.png",
    link3: "collection10.png",
    discoverpara: "flower art",
    discoverresource :"78 resources"
 },{
    id: 1,
    link: "collection6.png",
    link2: "collection7.png",
    link3: "collection8.png",
    discoverpara: "one line",
    discoverresource :"20 resources"
 },
 
  
]
export {DiscoverCollectionList};